import novaClient from "./client";
import type { NovaChoices, NovaCareTeamRole, NovaListResponse } from "./types";

export async function getChoices(): Promise<NovaChoices> {
  const res = await novaClient.get<NovaChoices>("/choices");
  return res.data;
}

export async function getCareTeamRoles(): Promise<NovaCareTeamRole[]> {
  const res = await novaClient.get<NovaListResponse<NovaCareTeamRole>>(
    "/choices/careTeamRoles",
  );
  return res.data.data;
}
